module.exports = __webpack_public_path__ + "img/pic_location_ChiayiCity.4bcba421.png";